module.exports = {
    gitVersion: 'dd3c45443bbc4424274ce5bf1d9df42709623a8a',
    appVersion: '25.2.3',
};
